import { render } from "./SellerCard.vue?vue&type=template&id=77bf36f8&scoped=true"
import script from "./SellerCard.vue?vue&type=script&lang=js"
export * from "./SellerCard.vue?vue&type=script&lang=js"

import "./SellerCard.vue?vue&type=style&index=0&id=77bf36f8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77bf36f8"]])

export default __exports__